export const theme = {
  colors: {
    primary: '#8B5CF6', // 主紫色
    primaryLight: '#A78BFA', // 浅紫色
    primaryDark: '#7C3AED', // 深紫色
    secondary: '#F3F4F6', // 浅灰色背景
    text: '#1F2937', // 主文字颜色
    textLight: '#6B7280', // 次要文字颜色
    white: '#FFFFFF',
    border: '#E5E7EB',
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '1rem',
    full: '9999px',
  },
}; 